export default __webpack_public_path__ + "static/media/Unknown.a5cfc05f.svg";